import { AdminPageHeader } from '@/components/patterns/admin-page'
import PriceChangesGlobalOrgNotice from '@/components/products/price-changes/PriceChangesGlobalOrgNotice'
import ProductPriceAdjustmentForm from '@/components/forms/ProductPriceAdjustmentForm'
import useIsGlobalOrg from '@/hooks/useIsGlobalOrg'
import { collectionQueries } from '@/lib/services/collections/collections.query'
import { supportsPriceAdjustmentsForOrganizationId } from '@/lib/services/price-adjustments/priceAdjustments.query'
import { priceAdjustmentSearchSchema } from '@/lib/services/price-adjustments/priceAdjustments.schema'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { Tags } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/products/price-changes/create')({
  component: PriceChangeCreateRouteComponent,
  validateSearch: (search) => priceAdjustmentSearchSchema.parse(search),
  loader: ({ context, params }) => {
    if (!context.ability.can('edit', 'products')) throw notFound()

    if (supportsPriceAdjustmentsForOrganizationId(params.orgId)) {
      void context.queryClient.ensureQueryData(
        collectionQueries.index({ organizationId: params.orgId, filters: {} })
      )
    }

    return { isReadOnly: false }
  },
})

export function PriceChangeCreateRouteComponent() {
  const isGlobalOrg = useIsGlobalOrg()

  if (isGlobalOrg) {
    return <PriceChangesGlobalOrgNotice />
  }

  return <PriceChangeCreatePage />
}

export function PriceChangeCreatePage() {
  const { collectionId } = Route.useSearch()

  return (
    <div className="space-y-4">
      <AdminPageHeader
        icon={Tags}
        title="Create Price Change"
        description="Adjust prices for products or collections during busy seasons."
      />
      <ProductPriceAdjustmentForm prefillCollectionId={collectionId || ''} showPageTreatment />
    </div>
  )
}
